/* @flow */
import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import createReducers from '../reducers';

const configureStore = ({ initialState, url }) => {

  const history = createBrowserHistory();

  const middlewares = [routerMiddleware(history), thunk];
  if (module.hot) {
    middlewares.push(createLogger());
  }

  const enhancers = composeWithDevTools(applyMiddleware(...middlewares));

  const store = createStore(
    createReducers(history),
    initialState || {},
    enhancers,
  );

  if (module.hot) {
    module.hot.accept('../reducers', async () => {
      try {
        const { default: nextReducer } = await import('../reducers');
        
        store.replaceReducer(nextReducer(history));
      } catch (error) {
        console.error(`==> 😭  Reducer hot reloading error ${error}`);
      }
    });
  }

  return {
    store,
    history,
  };
};

export default configureStore;
